import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { mockClasses } from './classes.mock';
import { IClassDTOIn } from '../interfaces/groups/class.interface';
import { environment } from '../../environments/environment';

export const mockClassesRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.CLASSES)) {
        const response: any = {
            status: 200,
            body: { classes: mockClasses },
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'GET' && request.url.includes(SubUrlsEnum.CLASS)) {
        const response: any = {
            status: 200,
            body: mockClasses.find((group: IClassDTOIn) => group.id === +request.url.replace(environment.wasoApi + SubUrlsEnum.CLASS, '')),
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
